import { themes, IrisTheme } from '@vimeo/iris/themes';
import { Mode } from '@vimeo/core/components/ThemeProvider';

type IrisThemeNames = Mode;

type IrisLegacyTheme = typeof themes['light'];

type ExcludeIrisTheme = {
  [Key in keyof IrisTheme]?: never;
};

/* Exclude these keys until Iris 7 is fully removed */
type ExcludeIrisLegacyTheme = {
  [Key in keyof IrisLegacyTheme]?: never;
};

export type CustomThemeSet<T> = {
  [Theme in IrisThemeNames]: T & ExcludeIrisTheme & ExcludeIrisLegacyTheme;
};

/**
 * This function merges together an IrisTheme and a set of custom themes. It is seperate from applyCustomTheme
 * so it can be reused in other files.
 */
export const mergeThemes = <T>(
  irisTheme: IrisTheme,
  customThemes: CustomThemeSet<T>,
): T & IrisTheme => {
  return {
    ...irisTheme,
    ...customThemes[irisTheme.name],
  };
};

/**
 * This function generates a styled-components theme-modification function that's passed
 * to ThemeProvider's theme prop
 */
export const applyCustomTheme =
  <T>(customThemes: CustomThemeSet<T>) =>
  (irisTheme: IrisTheme): T & IrisTheme =>
    mergeThemes<T>(irisTheme, customThemes);

export const getDefaultTheme = () => themes['light'];
